<template>
  <el-menu
    :default-active="activeIndex"
    class="el-menu-demo"
    style="justify-content: end;
    display: flex;"
    mode="horizontal"
    :router="true"
  >
    <el-menu-item index="/generate">生成授权</el-menu-item>
    <el-menu-item index="/license">授权详情</el-menu-item>
    <el-menu-item index="/licenseFile">预授权文件</el-menu-item>
    <el-submenu index="3">
      <template slot="title">个人中心</template>
      <el-menu-item @click="showUserInfo">个人信息</el-menu-item>
      <el-menu-item index="/users" v-show="showUi">用户管理</el-menu-item>
      <el-menu-item index="/register" v-show="showUi">添加用户</el-menu-item>
      <el-menu-item index="/login" @click="logoutButton">退出登陆</el-menu-item>
    </el-submenu>
    <UserInfo ref="UserInfo" />
  </el-menu>
</template>

<script>
import { mapActions } from "vuex";
import UserInfo from "@/components/UserInfo";

export default {
  name: "NavBar",
  components: {
    UserInfo
  },
  data() {
    return {
      activeIndex: this.$route.path
    };
  },
  methods: {
    ...mapActions("user", ["logout"]),
    logoutButton() {
      this.logout();
      setTimeout(() => this.$router.go(0), 0);
    },
    showUserInfo() {
      this.$refs.UserInfo.dialogShow();
    }
  },
  computed: {
    showUi() {
      if (this.$store.getters["user/isAdmin"].toString() === "true") {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped></style>
